<div class="w3-orange workSpace">
  <div class="centradoVertical w3-center" style="width: 80%; margin-left: auto; margin-right: auto; height: 60vh;">
    <div class="zonaImagen">
      <img src="./../../../assets/img/logoB.png" style="width: 40%;">
    </div>
    <!-- Módulos -->
    <div class="zonaPlataformas custom-scrollbar">
      @for (mod of modulesAct; track mod.name; let i = $index) {

        @if (isFirstModule(i)) {
          <div class="w3-row">
            <label class="tituloPlataforma"> 
              {{'menu.'+mod.platform | translate}} 
            </label>
          </div>
        }

        <div class="module-card" (click)="send(mod)">
          <div class="module-content">
            <mat-icon class="module-icon">apps</mat-icon>
            <span class="module-label">
              {{'menu.'+mod.name | translate}}
            </span>
          </div>
        </div>
      }
    </div>
  </div>
</div>